import React, { useEffect, useState } from "react";
import { action_options, app_modules } from "helpers/apps_modules_list";
import usePermission from "hooks/usePermission";
// For warehouse/in-stock


const Navdata = () => {
  // Permission section ============================
  // Use the usePermission hook to get permissions (automatically fetches and gives permissions from Redux)
  const { allPermissions } = usePermission();
  const user_permissions = allPermissions || [];

  // State data
  const [isUserManagement, setIsUserManagement] = useState(false);
  const [isMasters, setIsMasters] = useState(false);
  const [isInventory, setIsInventory] = useState(false);
  const [isWarehouse, setIsWarehouse] = useState(false);
  const [isEnquiry, setIsEnquiry] = useState(false);
  const [isQuotaion, setIsQuotation] = useState(false);
  const [isSalesOrder, setIsSalesOrder] = useState(false);
  const [isPurchaseManagement, setIsPurchaseManagement] = useState(false);
  const [isPaymentManagement, setIsPaymentManagement] = useState(false);
  const [iscurrentState, setIscurrentState] = useState("Dashboard");


  function updateIconSidebar(e: any) {
    if (e && e.target && e.target.getAttribute("sub-items")) {
      const ul: any = document.getElementById("two-column-menu");
      const iconItems: any = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id: any = item.getAttribute("sub-items");
        var menusId = document.getElementById(id);
        if (menusId) {
          (menusId.parentElement as HTMLElement).classList.remove("show");
        }
      });
      e.target.classList.add("active");
    }
  }

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");

    if (iscurrentState !== "User Management") setIsUserManagement(false);
    if (iscurrentState !== "Masters") setIsMasters(false);
    if (iscurrentState !== "Enquiry") setIsEnquiry(false);
    if (iscurrentState !== "Inventory") setIsInventory(false);
    if (iscurrentState !== "Warehouse") setIsWarehouse(false);
    if (iscurrentState !== "Quotation") setIsQuotation(false);
    if (iscurrentState !== "Sales Order") setIsSalesOrder(false);
    if (iscurrentState !== "Purchase Management") setIsPurchaseManagement(false);
    if (iscurrentState !== "Payment Management") setIsPaymentManagement(false);
  }, [
    iscurrentState,
    isUserManagement,
    isMasters,
    isEnquiry,
    isInventory,
    isWarehouse,
    isQuotaion,
    isSalesOrder,
    isPurchaseManagement,
    isPaymentManagement,
  ]);

  const menuItems: any = [
    {
      id: "dashboard",
      label: "Dashboard",
      icon: "ph ph-squares-four",
      link: "/dashboard",
      click: function (e: any) {
        setIscurrentState("Dashboard");
      },
      stateVariables: iscurrentState === "Dashboard",
      permissions: {
        app_name: app_modules.dashboard.app_name,
        module_name: app_modules.dashboard.modules.overview,
        action: action_options?.view,
      },
    },
    {
      id: "userManagement",
      label: "User Management",
      icon: "ph ph-users",
      link: "/#",
      click: function (e: any) {
        e.preventDefault();
        setIsUserManagement(!isUserManagement);
        setIscurrentState("User Management");
        updateIconSidebar(e);
      },
      stateVariables: isUserManagement,
      subItems: [
       
        {
          id: "organisations",
          label: "Organisation",
          icon: "ph-buildings",
          link: "/organisations-list",
          activeUrl: ["/organisation-form", "/edit-organisation/:id"],
          parentId: "userManagement",
          permissions: { app_name: app_modules.user_management.app_name, module_name: app_modules?.user_management.modules.organisation, action: action_options?.view }
        },
        {
          id: "departments",
          label: "Department",
          icon: "ph-briefcase",
          link: "/department-list",
          activeUrl: ["/department-form", "/department-form/:id"],
          parentId: "userManagement",
          permissions: { app_name: app_modules.user_management.app_name, module_name: app_modules?.user_management.modules?.department, action: action_options?.view }
        },

        {
          id: "teams",
          label: "Team",
          icon: "ph-users-three",
          link: "/team-list",
          activeUrl: ["/team-forms", "/team-forms/:id"],
          parentId: "userManagement",
          permissions: { app_name: app_modules.user_management.app_name, module_name: app_modules?.user_management.modules?.team, action: action_options?.view }
        },
        {
          id: "userTypes",
          label: "User Type",
          icon: "ph-identification-card",
          link: "/userType-list",
          activeUrl: ["userType-list", "/userType-form", "/userType/:id"],
          parentId: "userManagement",
          permissions: { app_name: app_modules.user_management.app_name, module_name: app_modules?.user_management.modules?.userType, action: action_options?.view }
        },
        {
          id: "users",
          label: "User",
          icon: "ph-user-circle",
          link: "/user-list",
          activeUrl: ["/user-form", "/user-form/", "/user-form/:id"],
          parentId: "userManagement",
          permissions: { app_name: app_modules.user_management.app_name, module_name: app_modules?.user_management.modules?.user, action: action_options?.view }
        },
        // {
        //   id: "Modules",
        //   label: "Module",
        //   icon: "ph-cube",
        //   link: "/master/module-list",
        //   activeUrl: ["/master/module-form", "/master/edit-module-form"],
        //   parentId: "userManagement",
        //   permissions: { app_name: app_modules.user_management.app_name, module_name: app_modules?.user_management.modules?.module, action: action_options?.view }
        // },
      ],
      // permissions: {app_name: app_modules.master.app_name, module_name: app_modules.master.modules.master, action: action_options?.view}
    },

    // (!areAllPermissionsFalse(isAllMasterHavePermission) &&
    // {
    //   label: "Masters",
    //   isHeader: true,
    // }),
    {
      id: "master",
      label: "Masters",
      icon: "ph-storefront",
      link: "/#",
      click: function (e: any) {
        e.preventDefault();
        setIsMasters(!isMasters);
        setIscurrentState("Masters");
        updateIconSidebar(e);
      },
      stateVariables: isMasters,
      subItems: [

        {
          id: 1,
          label: "Category",
          icon: "ph-folder",
          link: "/master/category",
          parentId: "/master",
          activeUrl: ["/master/add-category", "/master/edit-category/:id"],
          permissions: { app_name: app_modules.master.app_name, module_name: app_modules.master.modules.category, action: action_options?.view }
        },
        {
          id: 2,
          label: "Sub Category",
          icon: "ph-folders",
          link: "/master/sub-category",
          parentId: "/master",
          activeUrl: ["/master/add-sub-category", "/master/edit-sub-category/:id"],
          permissions: { app_name: app_modules.master.app_name, module_name: app_modules.master.modules.subcategory, action: action_options?.view }
        },
        {
          id: 3,
          label: "Type",
          icon: "ph-tag",
          link: "/master/type",
          parentId: "/master",
          activeUrl: ["/master/add-type", "/master/edit-type/:id"],
          permissions: { app_name: app_modules.master.app_name, module_name: app_modules.master.modules.type, action: action_options?.view }
        },
        {
          id: 4,
          label: "Unit",
          icon: "ph-ruler",
          link: "/master/uom",
          parentId: "/master",
          activeUrl: ["/master/add-uom", "/master/edit-uom/:id"],
          permissions: { app_name: app_modules.master.app_name, module_name: app_modules.master.modules.unit, action: action_options?.view }
        },
        {
          id: 5,
          label: "GST",
          icon: "ph-receipt",
          link: "/master/gst",
          parentId: "/master",
          activeUrl: ["/master/add-gst", "/master/edit-gst/:id"],
          permissions: { app_name: app_modules.master.app_name, module_name: app_modules.master.modules.gst, action: action_options?.view }
        },
        {
          id: 6,
          label: "HSN Code",
          icon: "ph-barcode",
          link: "/master/hsn-codes",
          parentId: "/master",
          activeUrl: ["/master/add-hsn-code", "/master/edit-hsn-code/:id"],
          permissions: { app_name: app_modules.master.app_name, module_name: app_modules.master.modules.hsn_code, action: action_options?.view }
        },

        {
          id: 7,
          label: "SAC Code",
          icon: "ph-barcode",
          link: "/master/sac-codes",
          parentId: "/master",
          activeUrl: ["/master/add-sac-code", "/master/edit-sac-code/:id"],
          permissions: { app_name: app_modules.master.app_name, module_name: app_modules.master.modules.sac_code, action: action_options?.view }
        },
        {
          id: 8,
          label: "Currency",
          icon: "ph-currency-circle-dollar",
          link: "/master/currency",
          parentId: "master",
          activeUrl: ["/master/add-currency", "/master/edit-currency/:id"],
          permissions: { app_name: app_modules.master.app_name, module_name: app_modules.master.modules.currency, action: action_options?.view }
        },
        {
          id: 9,
          label: "Make",
          icon: "ph-wrench",
          link: "/master/make",
          parentId: "master",
          activeUrl: ["/master/add-make", "/master/edit-make/:id"],
          permissions: { app_name: app_modules.master.app_name, module_name: app_modules.master.modules.make, action: action_options?.view }
        },
        {
          id: 10,
          label: "Model",
          icon: "ph-car",
          link: "/master/model",
          parentId: "master",
          activeUrl: ["/master/add-model", "/master/edit-model/:id"],
          permissions: { app_name: app_modules.master.app_name, module_name: app_modules.master.modules.model, action: action_options?.view }
        },
        {
          id: 11,
          label: "Product",
          icon: "ph-package",
          link: "/master/product",
          parentId: "master",
          activeUrl: ["/master/add-product", "/master/edit-product/:id"],
          permissions: { app_name: app_modules.master.app_name, module_name: app_modules.master.modules.product, action: action_options?.view }
        },

        {
          id: 12,
          label: "Customer",
          icon: "ph-buildings",
          link: "/master/company",
          parentId: "company",
          activeUrl: ["/master/add-company", "/master/edit-company/:id", "/master/view-company/:id"],
          permissions: { app_name: app_modules.master.app_name, module_name: app_modules.master.modules.customer, action: action_options?.view }
        },
        {
          id: 13,
          label: "Warehouse",
          link: "/master/warehouse-list",
          icon: "ph ph-house",
          parentId: "master",
          activeUrl: [
            "/master/warehouse-form",
            "/master/configure-warehouse/:id",
            "/master/warehouse-forms/:id",
          ],
          permissions: { app_name: app_modules.master.app_name, module_name: app_modules.master.modules.warehouse, action: action_options?.view }
        },
        {
          id: 14,
          label: "Supplier",
          icon: "ph-truck",
          link: "/master/supplier",
          parentId: "master",
          activeUrl: [
            "/master/add-supplier",
            `/master/edit-supplier/:id`,
            "/master/view-supplier/:id",
          ],
          permissions: { app_name: app_modules.master.app_name, module_name: app_modules.master.modules.supplier, action: action_options?.view }
        },
        {
          id: 15,
          label: "Terms And Condition",
          icon: "ph ph-file-text",
          link: "/master/terms-and-condition",
          parentId: "master",
          activeUrl: [
            "/master/add-terms-and-condition",
            "/master/edit-terms-and-condition/:id",
          ],
          permissions: { app_name: app_modules.master.app_name, module_name: app_modules.master.modules.terms_and_conditions, action: action_options?.view }
        },
     

      ],
    },
    {
      id: "enquiry",
      label: "Enquiry",
      icon: "ph-question",
      link: "/#",
      click: function (e: any) {
        e.preventDefault();
        setIsEnquiry(!isEnquiry);
        setIscurrentState("Enquiry");
        updateIconSidebar(e);
      },
      stateVariables: isEnquiry,
      subItems: [
        {
          id: 1,
          label: 'Sales',
          icon: "ph-package",
          link: '/enquiry/product/enquiry_log',
          parentId: 'enquiry',
          activeUrl: ['/enquiry/add-product-enquiry', '/enquiry/product/enquiry_log/view/:id', '/enquiry/product/edit/:id', '/enquiry/product/enquiry_log/quotation/create/:id', '/enquiry/product/junk', '/enquiry/product/junk/view/:id', '/enquiry/product/draft', '/enquiry/followups/product/:id'],
          permissions: { app_name: app_modules.enquiry.app_name, module_name: app_modules.enquiry.modules?.product, action: action_options?.view }
        },


        {
          id: 2,
          label: 'Service',
          icon: "ph-gear",
          link: '/enquiry/service/enquiry_log',
          parentId: 'enquiry',
          activeUrl: ['/enquiry/add-services-enquiry', '/enquiry/service/enquiry_log/view/:id', '/enquiry/service/edit/:id', '/enquiry/service/enquiry-log/quotation/create/:id', '/enquiry/service/junk', '/enquiry/service/junk/view/:id', '/enquiry/service/draft', '/enquiry/service/draft/edit/:id'],
          permissions: { app_name: app_modules.enquiry.app_name, module_name: app_modules.enquiry.modules?.service, action: action_options?.view }
        },
      ]
    },
    {
      id: "quotation",
      label: "Quotation",
      icon: "ph-pencil",
      link: "/#",
      click: function (e: any) {
        e.preventDefault();
        setIsQuotation(!isQuotaion);
        setIscurrentState("Quotation");
        updateIconSidebar(e);
      },
      stateVariables: isQuotaion,
      subItems: [
        {
          id: 1,
          label: 'Sales',
          icon: "ph-package",
          link: '/quotation/product/log',
          parentId: 'quotation',
          activeUrl: ['/quotation/product', '/quotation/product/log', '/quotation/product/draft', '/quotation/product/add', '/quotation/product/edit/:id', '/quotation/product/view/:id'],
          permissions: { app_name: app_modules.quotation.app_name, module_name: app_modules.quotation.modules?.product, action: action_options?.view }
        },
        {
          id: 2,
          label: 'Service',
          icon: "ph-gear",
          link: '/quotation/service/log',
          parentId: 'quotation',
          activeUrl: ['/quotation/service', '/quotation/service/log', '/quotation/service/draft', '/quotation/service/add', '/quotation/service/edit/:id', '/quotation/service/view/:id'],
          permissions: { app_name: app_modules.quotation.app_name, module_name: app_modules.quotation.modules?.service, action: action_options?.view }
        },
      ]
    },
    {
      id: "sales_order",
      label: "Order",
      icon: "ph-shopping-cart-simple",
      link: "/#",
      click: function (e: any) {
        e.preventDefault();
        setIsSalesOrder(!isSalesOrder);
        setIscurrentState("Sales Order");
        updateIconSidebar(e);
      },
      stateVariables: isSalesOrder,
      subItems: [
        {
          id: 1,
          label: 'Sales',
          icon: "ph-package",
          link: '/sales_order/product/sales_order_log',
          parentId: 'sales_order',
          activeUrl: ['/sales_order/add_product_sales_order', '/sales_order/product/sales_order_log/view/:id', '/sales_order/product/edit/:id', '/sales_order/product/junk', '/sales_order/product/junk/view/:id', '/sales_order/product/draft', '/sales_order/product/draft/edit/:id'],
          permissions: { app_name: app_modules.sales_order.app_name, module_name: app_modules.sales_order.modules?.product, action: action_options?.view }
        },

        {
          id: 2,
          label: 'Service',
          icon: "ph-gear",
          link: '/sales_order/service/sales_order_log',
          parentId: 'sales_order',
          activeUrl: ['/sales_order/add_services_sales_order' ,'/sales_order/service/sales_order_log/view/:id', '/sales_order/service/edit/:id', '/sales_order/service/junk', '/sales_order/service/junk/view/:id', '/sales_order/service/draft', '/sales_order/service/draft/edit/:id', '/sales_order/service/challan/view/:id', '/sales_order/service/challan/:id', '/sales_order/service/challan/return/:challanId', '/sales_order/service/challan/return-view/:challanId', '/sales_order/service/challan/return-edit/:challanId/:returnId'],
          permissions: { app_name: app_modules.sales_order.app_name, module_name: app_modules.sales_order.modules?.service, action: action_options?.view }
        }
      ]
    },
    {
      id: "purchase_management",
      label: "Purchase Management",
      icon: "ph-question",
      link: "/#",
      click: function (e: any) {
        e.preventDefault();
        setIsPurchaseManagement(!isPurchaseManagement);
        setIscurrentState("Purchase Management");
        updateIconSidebar(e);
      },
      stateVariables: isPurchaseManagement,
      subItems: [
        // { id: 1, label: "RFQ", link: "/rfq", parentId: "procurement" },
        {
          id: 1,
          label: 'Purchase Request',
          icon: "ph-file-text",
          link: '/purchase-management/purchase-request',
          parentId: 'purchase_management',
          activeUrl: ['/purchase-management/create-purchase-request', '/purchase-request-view-details/:id', '/edit-purchase-request/:id', '/approve-purchase-request-form/:id'],
          permissions: { app_name: app_modules.purchase_management.app_name, module_name: app_modules.purchase_management.modules?.purchase_request, action: action_options?.view }
        },

        {
          id: 2,
          label: 'Purchase Order',
          icon: "ph-shopping-cart",
          link: '/purchase-management/purchase-order',
          parentId: 'purchase_management',
          activeUrl: ['/purchase-request-approved-pr-view-details', '/purchase-order-order-details', '/purchase-request-approved-create-purchase-order',"/create-direct-purchase-order","/create-purchase-order/:pr_id","/purchase-order-view-details/:po_id","/edit-purchase-order/:po_id","/purchase-request-approved-pr-view-details/:pr_id"],
          permissions: { app_name: app_modules.purchase_management.app_name, module_name: app_modules.purchase_management.modules?.purchase_order, action: action_options?.view }
        }
      ]
    },
   

    // Inventory sidemenu

    // (!areAllPermissionsFalse(isAllInventoryHavePermission) &&
    // {
    //   label: "Inventory",
    //   isHeader: true,
    // }),
    {
      id: "inventory",
      label: "Inventory",
      icon: "ph-shopping-cart",
      link: "/#",
      click: function (e: any) {
        e.preventDefault();
        setIsInventory(!isInventory);
        setIscurrentState("Inventory");
        updateIconSidebar(e);
      },
      stateVariables: isInventory,
      subItems: [
        {
          id: 1,
          label: "In Stock",
          icon:  "ph ph-house",
          link: "/inventory",
          parentId: "inventory",
          activeUrl: ["/inventory/stock-overview/in-stock", "/inventory/stock-overview/in-stock/view/:id", "/inventory/stock-overview/damaged", "/inventory/stock-overview/damaged/view/:id","/inventory-item-details/:id/:warehouseId"],
          permissions: { app_name: app_modules?.inventory.app_name, module_name: app_modules?.inventory.modules?.in_stock, action: action_options?.view }
        },

        {
          id: 2,
          label: "Reorder Level",
          icon: "ph-warning",
          link: "/inventory-reorder-level",
          parentId: "inventory",
          activeUrl: ["/inventory/reorder-level/define-reorder"],
          permissions: { app_name: app_modules?.inventory.app_name, module_name: app_modules?.inventory.modules?.reorder_level, action: action_options?.view }
        },
      ],
    },
    {
      id: "warehouse",
      label: "Warehouse",
      icon: "ph ph-house",
      link: "/#",
      click: function (e: any) {
        e.preventDefault();
        setIsWarehouse(!isWarehouse);
        setIscurrentState("Warehouse");
        updateIconSidebar(e);
      },
      stateVariables: isWarehouse,
      subItems: [
        {
          id: 1,
          label: "Stock Overview",
          icon: "ph-chart-line",
          link: "/warehouse/stock-overview",
          parentId: "warehouse",
          activeUrl: ["/warehouse/stock-overview/daily-log","/warehouse/stock-overview/in-stock","/warehouse/stock-overview/damage","/warehouse/stock-overview/in-stock/view/:id", "/warehouse/stock-overview/damaged", "/warehouse/stock-overview/damaged/view/:id","/warehouse-stock-overview-instock-item-details/:warehouse_id/:product_id"],
          permissions: { app_name: app_modules?.warehouse.app_name, module_name: app_modules?.warehouse.modules?.stock_overview, action: action_options?.view }
        },

        {
          id: 2,
          label: "Item Inward",
          icon: "ph-arrow-down",
          link: "/warehouse-item-inward",
          parentId: "warehouse",
          activeUrl: ["/warehouse/item-inward", "/warehouse-item-inward-create-grn/:id/:warehouse_id","/warehouse-item-inward-grn-item-details/:id","/grn-view-details/:inventory_id","/warehouse-item-inward-edit-grn/:po_id/:inventory_id","/grn-items-view-details/:inventory_id/:product_id","/warehouse/item-inward/returned-accessories/:challan_id/view","/warehouse/item-inward/returned-accessories/:challan_id/process","/warehouse/item-inward/returned-accessories/grn/:inward_id","/warehouse/item-inward/returned-accessories/grn/:inward_id/edit" ],
          permissions: { app_name: app_modules?.warehouse.app_name, module_name: app_modules?.warehouse.modules?.item_inward, action: action_options?.view }
        },
        {
          id: 3,
          label: "Packing",
          icon: "ph-package",
          link: "/warehouse-packing",
          parentId: "warehouse",
          activeUrl: ["/warehouse-packing", "/warehouse-packing-done", '/warehouse-create-packing/:id', '/warehouse-allocation-create-packing/:id', "/warehouse-item-request-create-packing/:id", "/warehouse-packing-view-details/:id", "/warehouse-packing-done-view-details/:id","/warehouse-packing-done-edit-details/:id"],
          permissions: { app_name: app_modules?.warehouse.app_name, module_name: app_modules?.warehouse.modules?.packing, action: action_options?.view }
        },
        {
          id: 4,
          label: "Dispatch",
          icon: "ph-truck",
          link: "/warehouse-dispatch",
          parentId: "warehouse",
          activeUrl: [ "/add-warehouse-dispatch", "/dispatch-view-warehosue-allocations/:dispatchDoneId","/dispatch-view-details/:dispatch_id","/edit-warehouse-dispatch/:dispatch_id"],
          permissions: { app_name: app_modules?.warehouse.app_name, module_name: app_modules?.warehouse.modules?.dispatch, action: action_options?.view }
        },
      ],
    },
     {
      id: "payment_management",
      label: "Payment Management",
      icon: "ph-currency-inr",
      link: "/#",
      click: function (e: any) {
        e.preventDefault();
        setIsPaymentManagement(!isPaymentManagement);
        setIscurrentState("Payment Management");
        updateIconSidebar(e);
      },
      stateVariables: isPaymentManagement,
      subItems: [
        {
          id: 1,
          label: 'Sales',
          icon: "ph-package",
          link: '/payment-management/product',
          parentId: 'payment_management',
          activeUrl: ["/payment-management/product/order/record-payment/:id", "/payment-management/product/retention/record-payment/:id"],
          permissions: { app_name: app_modules.payment_management.app_name, module_name: app_modules.payment_management.modules?.product, action: action_options?.view }
        },

        {
          id: 2,
          label: 'Service',
          icon: "ph-gear",
          link: '/payment-management/service',
          parentId: 'payment_management',
          activeUrl: ["/payment-management/service/order/record-payment/:id", "/payment-management/service/retention/record-payment/:id"],
          permissions: { app_name: app_modules.payment_management.app_name, module_name: app_modules.payment_management.modules?.service, action: action_options?.view }
        }
      ]
    },
  ];


  const hasPermission = (app_name: string, module_name: string, permission: string): boolean => {
    return user_permissions?.some((app: any) =>
      app.apps_name === app_name &&
      app.modules_permissions?.some((module: any) =>
        module.modules_name === module_name &&
        module.permissions?.[permission] === true
      )

    );
  };

  const filterItemsWithPermissions = (items: any[]): any[] => {
    return items
      .map((item: any) => {
        if (item.subItems?.length) {
          const filteredSubItems = filterItemsWithPermissions(item.subItems);
          if (filteredSubItems.length) {
            return { ...item, subItems: filteredSubItems };
          }
          return null;
        }
        if (item.permissions) {
          const { app_name, module_name, action } = item.permissions;
          return hasPermission(app_name, module_name, action) ? item : null;
        }
        // If no permissions are defined, include the item (for headers, etc.)
        return item;
      })
      .filter(Boolean);
  };

  // Filter out false values first (for conditional headers), then apply permissions filter
  const validMenuItems = menuItems.filter(Boolean);
  const filteredMenuItems = filterItemsWithPermissions(validMenuItems);

  return (
    <React.Fragment>
      {filteredMenuItems}
    </React.Fragment>
  );
};

export default Navdata;
